var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeedbackThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41665 10.082L10.0833 1.83203C10.8127 1.83203 11.5121 2.12176 12.0279 2.63749C12.5436 3.15321 12.8333 3.85269 12.8333 4.58203V8.2487H18.0216C18.2874 8.24569 18.5506 8.30049 18.7931 8.40931C19.0356 8.51814 19.2515 8.67837 19.4259 8.87892C19.6002 9.07947 19.7289 9.31553 19.803 9.57076C19.8771 9.82599 19.8949 10.0943 19.855 10.357L18.59 18.607C18.5237 19.0442 18.3016 19.4427 17.9647 19.729C17.6278 20.0154 17.1988 20.1704 16.7566 20.1654H6.41665M6.41665 10.082V20.1654M6.41665 10.082H3.66665C3.18042 10.082 2.7141 10.2752 2.37028 10.619C2.02647 10.9628 1.83331 11.4291 1.83331 11.9154V18.332C1.83331 18.8183 2.02647 19.2846 2.37028 19.6284C2.7141 19.9722 3.18042 20.1654 3.66665 20.1654H6.41665",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedbackThumbsUp);
export default __webpack_public_path__ + "static/media/icon-feedback-thumbs-up.f32c9d03802caee3c7ec4c3a168d6258.svg";
export { ForwardRef as ReactComponent };